export const initialState = {
  editForm: true,
  editFormSecond: true,
};
